import React from 'react';
import $ from 'jquery';
import delImg from "../../src/components/images/delete.svg";
import authService from '../../src/components/api-authorization/AuthorizeService';
export class ModalPopUpTable extends React.Component {
    constructor(props) {
        super(props);
        this.state = { studydrp: [], timepointdrp: [{}], rows: [{}], studyTimepointData: [], studyselected: [{}],username:null};
        this.BindTimepointDropdown = this.BindTimepointDropdown.bind(this);
        this.handleChange = this.handleChange.bind(this);
        
    }

   async componentDidMount() {
       const [isAuthenticated, user] = await Promise.all([authService.isAuthenticated(), authService.getUser()]);
     
       this.setState({
             username: user && user.name           
                  
        }, () =>
            console.log(this.state));
        this.getStudyOptions();
       
        if (this.props.scanDto !== undefined) {
            if (this.props.scanDto.studyTimepointLookup != null)
                this.BindTimepointDropdown(Object.values(this.props.scanDto.studyTimepointLookup));
            }
        }
    

    InitialSetting = () => {
        $(".txtStudy").hide();
        $(".txtTimepoint").hide();
    }
    GetRows = () => {
        const studies = Object.keys(this.props.scanDto.studyTimepointLookup);
        this.setState({
            rows: studies
        });
    }
    BindTimepointDropdown = (timepointData) => {
        const studies = Object.keys(this.props.scanDto.studyTimepointLookup);

        studies.map((item, idx) =>
            this.getTimepointOptions(item, idx, timepointData)
        );
        this.setState({
            loading: true
        }, () =>
            this.GetRows());
    }
    handleChange = idx => e => {
        const { value } = e.target;
        const rows = [...this.state.rows];

        if (e.target.name === "studies") {
            rows[idx] = value;
            this.setState({
                rows
            });
            if (e.target.value === "Other") {
                $("#txtStudy" + idx).show();
            }
            else {
                $("#txtStudy" + idx).hide();
            }

            this.getTimepointOptions(e.target.value, e.target.id);
        }
        if (e.target.name === "timepoints" && e.target.value === "Other") {
            $("#txtTimepoint" + idx).show();
        }
        if (e.target.name === "timepoints" && e.target.value !== "Other") {
            $("#txtTimepoint" + idx).hide();
        }
    };
    handleAddRow = () => {
        const item = {
            studies: "",
            timepoints: ""
        };
        this.setState({
            rows: [...this.state.rows, item]
        }, () => {
            this.disableSelectedStudies();
        });
    };
    disableSelectedStudies = () => {
        var studies = []
        var txtStudy = ""

        $("td").find(".drpstudies").each(function () {
            var Study = $(this).val();

            if (Study !== "Other") {
                studies.push(Study);
            }
            else {
                txtStudy = $(this).closest("tr").find(".txtStudy").val();

                studies.push(txtStudy);
            }
        });
        var rowIndex = ($("#tab_logic tbody  tr").length) - 1;
        $("#txtStudy" + rowIndex).hide();
        $("#txtTimepoint" + rowIndex).hide();

        studies.forEach((item, index) => {
            var study = item
            if (study !== "Other")
                $("#" + rowIndex + " option[value*='" + study + "']").prop('disabled', 'disabled');
        }
        );
    }
    handleRemoveRow = () => {
        this.setState({
            rows: this.state.rows.slice(0, -1)
        });
    };
    handleRemoveSpecificRow = (idx) => () => {
        const rows = [...this.state.rows]
        rows.splice(idx, 1)
        this.setState({ rows })
    }

    render() {
        return (

            <div>
                <div className="container">
                    <div className="row clearfix">
                        <div className="col-md-12 column">
                            <button onClick={this.handleAddRow} className="btn btn-primary">
                                Add New Row
                                </button>
                            <table
                                className="table table-bordered table-hover"
                                id="tab_logic"
                            >

                                <thead>
                                    <tr>
                                        <th className="text-center" style={{ "width": "40%" }}> Study </th>
                                        <th className="text-center" style={{ "width": "40%" }}> Timepoint </th>
                                        <th className="text-center" style={{ "width": "10%" }}> Delete </th>

                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.rows.map((item, idx) => (
                                        <tr id="addr0" key={idx}>

                                            <td>
                                                <select className="browser-default custom-select drpstudies" name="studies" id={idx}
                                                    value={this.state.rows[idx]}
                                                    onChange={this.handleChange(idx)}
                                                ><option defaultValue="selected">Select Study</option>
                                                    {this.state.studydrp.map((v,index) => (
                                                        <option value={v.id} key= {index} >{v.studyName}</option>
                                                    ))}

                                                </select>

                                                <input type="text" className="txtStudy" id={"txtStudy" + idx} style={{ "display": "none" }} placeholder="Enter Study type" />

                                            </td>
                                            <td>

                                                <select className="browser-default custom-select drptimepoints"
                                                    name="timepoints" id={"drp" + idx}
                                                    //value={this.state.rows[idx].timepoints}
                                                    onChange={this.handleChange(idx)}
                                                >

                                                </select>
                                                <input type="text" className="txtTimepoint" id={"txtTimepoint" + idx} style={{ "display": "none" }} placeholder="Enter Timepoint type" />
                                            </td>
                                            <td>

                                                <button className="btn btn-primary" onClick={this.handleRemoveSpecificRow(idx)}>
                                                    <center>   <img src={delImg} alt="" /></center>
                                                </button>
                                            </td>

                                        </tr>

                                    ))}

                                </tbody>
                            </table>

                        </div>
                    </div>
                </div>
            </div>
        );
    }
    async getStudyOptions() {
        this.setState({
            loading: false
        }, () =>
            console.log(this.state));

        $.ajax({
            url: '/ScanFilter/GetAssignedStudiesDropdown',
            type: 'GET',
            dataType: 'JSON',
            data: { username: this.state.username },
            success: function (data) {
                this.setState({
                    studydrp: data
                });
            }.bind(this)
        });
    }

    getTimepointOptions(selectedStudyId, idx, timepointData) {
        $.ajax({
            url: '/ScanFilter/GetTimepointsDropdown',
            type: 'GET',
            dataType: 'JSON',
            data: { studyId: selectedStudyId },
            success: function (data) {
                var $timepointdrp = $("#drp" + idx);
                $timepointdrp.empty();
                $.each(data, function (index, value) {
                    $timepointdrp.append("<option value='" + value + "'>" + value + "</option>");
                });
                if (timepointData !== null && typeof timepointData !== "undefined" && !data.includes(timepointData[idx])) {
                    $timepointdrp.append("<option value='" + timepointData[idx] + "'>" + timepointData[idx] + "</option>");
                }
                if (timepointData !== null && typeof timepointData !== "undefined") { $timepointdrp.val(timepointData[idx]); }

                $timepointdrp.append("<option value=Other>Other [Please Specify]</option>");
            }
        });
    }
    
}